import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { ExposureDefinitionType } from '@/__generated__/graphql';
import { toTitleCase } from '@/util/string';

export type ExposureModeDropdownProps = {};

export const EXPOSURE_MODE_PARAM = 'exposureMode';

export const ExposureModeDropdown: FC<ExposureModeDropdownProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...Object.values(ExposureDefinitionType).map(
        (l): DropdownOption => ({ label: toTitleCase(l), value: l }),
      ),
    ],
    [],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const exposureModeValue = searchParams.get(EXPOSURE_MODE_PARAM);
    return options.find((o) => o.value === exposureModeValue) || options[0];
  }, [searchParams, options]);

  return (
    <DropdownButton
      options={options}
      className="text-nowrap text-fgMain"
      defaultOption={defaultOption}
      name="Exposure Mode:"
      listClassName="z-50"
      testId="exposure-mode-dropdown"
      onChange={({ value }) => {
        if (typeof value !== 'string') return;
        if (value === 'all') {
          setSearchParams((p) => {
            p.delete(EXPOSURE_MODE_PARAM);
            return p;
          });
        } else {
          setSearchParams((p) => {
            p.set(EXPOSURE_MODE_PARAM, value);
            return p;
          });
        }
      }}
    />
  );
};
